exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-item {\n  width: 100%;\n  background: #fff;\n  border: none;\n  border-bottom: 1px solid #f8f8f8;\n  height: 26px;\n}\n\n.dropdown-menu {\n  padding: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/production/sne-pro/src/app/component/account-booking/account-booking/account-booking.component.css
// module id = ../../../../../src/app/component/account-booking/account-booking/account-booking.component.css
// module chunks = main